const competencies = [
  { icon: 'ri-focus-3-line', title: 'Постановка целей', desc: 'Как связывать задачи сотрудников с целями подразделения и бизнеса, чтобы каждый понимал, зачем работает.' },
  { icon: 'ri-share-forward-line', title: 'Делегирование', desc: 'Как передавать не только задачи, но и ответственность за результат без микроменеджмента.' },
  { icon: 'ri-eye-line', title: 'Контроль', desc: 'Как контролировать выполнение через контрольные точки, а не через постоянное вмешательство в процесс.' },
  { icon: 'ri-chat-3-line', title: 'Обратная связь', desc: 'Как корректировать поведение и поддерживать сильные результаты, не демотивируя сотрудников.' },
  { icon: 'ri-fire-line', title: 'Мотивация', desc: 'Как понимать факторы, влияющие на вовлечённость конкретных сотрудников, и создавать условия для их работы.' },
  { icon: 'ri-seedling-line', title: 'Развитие сотрудников', desc: 'Как выявлять потенциал, ставить развивающие задачи и помогать сотрудникам расти в должности.' },
  { icon: 'ri-team-line', title: 'Командное взаимодействие', desc: 'Как формировать правила работы и взаимодействия внутри команды для достижения совместного результата.' },
  { icon: 'ri-scales-3-line', title: 'Управление конфликтами', desc: 'Как не допускать разрушительного влияния конфликтов на результат и переводить их в рабочие решения.' },
  { icon: 'ri-lightbulb-line', title: 'Принятие решений', desc: 'Как развивать самостоятельность сотрудников и не становиться единственным центром принятия решений.' },
  { icon: 'ri-vip-crown-line', title: 'Лидерство', desc: 'Как добиваться следования за руководителем не только благодаря должностным полномочиям.' },
];

export default function CoreCompetencies() {
  return (
    <section id="skills" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Чему необходимо научить руководителя
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Эффективное управление командой — это набор конкретных управленческих компетенций, которые можно развить на практике
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {competencies.map((c) => (
            <div key={c.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${c.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{c.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}